import Carousel from './carousel';
import Navbar from '../Navbar/navbar';

import '../../../bootstrap.min.css';

const HeroStart = () => {
    return (
        <div className="container-fluid position-relative p-0">
            <Navbar />
            <Carousel />
        </div>
    )
}
export default HeroStart;